import React, { Fragment, useContext } from 'react';
import { appPath, APP_PATHS } from '../../../utils/appPaths.js';
import sad from '../../../assets/images/other-images/sad.png';
import { Link } from 'react-router-dom';
import { Container, Button, Media, Col } from "reactstrap"
import { BACK_TO_HOME_PAGE } from "../../../Constant";
import CustomizerContext from '../../../_helper/Customizer';
import { H2, P } from '../../../AbstractElements';

const Error404 = () => {
    const { layoutURL } = useContext(CustomizerContext);
    return (
        <Fragment>
            <div className="page-wrapper">
                <div className="error-wrapper">
                    <Container>
                        <Media body className="img-100" src={sad} alt="" />
                        <div className="error-heading text-center">
                            <H2 attrH2={{ className: "font-danger text-center" }} >{"Expired"}</H2>
                        </div>
                        <Col md="8 offset-md-2">
                            <P attrPara={{ className: "sub-content text-center" }} >{"The link you are trying to access has expired."}</P>
                        </Col>
                        <div className="text-center mt-3">
                            <Link to={appPath('/dashboard')}>
                                <Button color="danger-gradien" size='lg'>{BACK_TO_HOME_PAGE}</Button>
                            </Link>
                        </div>
                    </Container>
                </div>
            </div>
        </Fragment>
    );
};

export default Error404;
